"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saturateImage = void 0;

var _RgbaImageBuffer = _interopRequireDefault(require("../RgbaImageBuffer"));

var colorSpaceConversions = _interopRequireWildcard(require("../colorSpaceConversions"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Saturates the given image
 *
 * @param {RgbaImageBuffer} imgBuffer Image Buffer base
 * @param {Number} saturationPercentage Saturation percentage for the operation
 * @returns {RgbaImageBuffer} Converted image
 */


var saturateImage = function saturateImage(imgBuffer, saturationPercentage) {
  var result = imgBuffer.copy();

  for (var i = 0; i < result.pixels.length; i += _RgbaImageBuffer.default.NUM_CHANNELS) {
    var rComponent = imgBuffer.pixels[i];
    var gComponent = imgBuffer.pixels[i + 1];
    var bComponent = imgBuffer.pixels[i + 2];
    var HSLPixel = colorSpaceConversions.RGBToHSL({
      r: rComponent,
      g: gComponent,
      b: bComponent
    });
    var newRGBPixel = colorSpaceConversions.HSLToRGB({
      h: HSLPixel.h,
      s: HSLPixel.s * saturationPercentage / 100,
      l: HSLPixel.l
    });
    result.pixels[i] = newRGBPixel.r;
    result.pixels[i + 1] = newRGBPixel.g;
    result.pixels[i + 2] = newRGBPixel.b;
  }

  return result;
};

exports.saturateImage = saturateImage;